import { render, staticRenderFns } from "./VirtualKeyboardNew.vue?vue&type=template&id=235c52be&scoped=true&"
import script from "./VirtualKeyboardNew.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboardNew.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboardNew.vue?vue&type=style&index=0&id=235c52be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c52be",
  null
  
)

export default component.exports